import { createFileRoute } from '@tanstack/react-router'
import { LearnPage } from '@/features/learn/learn-page'

export const Route = createFileRoute('/_authenticated/learn/')({
  staticData: { title: 'Learn' },
  component: LearnPage,
})
